<div [matTooltip]="(verified ? 'verification.id.verified' : 'verification.id.notVerified') | translate"
     matTooltipPosition="below">
     <button mat-icon-button (click)="editVerificationStatus()">
       <mat-icon [style.color]="verified ? '#4caf50' : '#9E9E9E'">
         {{ verified ? 'verified_user' : 'verified_user' }}
       </mat-icon>
     </button>
</div>